<mat-dialog-content>
  <label for="urlInput">
    <h2>Import Domain Story</h2>
  </label>
  <mat-form-field class="form-width" color="accent">
    <mat-label>URL</mat-label>
    <input
      matInput
      class="dense-8"
      type="url"
      id="urlInput"
      subscriptSizing="dynamic"
      [value]="fileUrl | async"
      (input)="updateUrl($event)"
    />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <br />
  <div>
    <button mat-flat-button (click)="close()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      (click)="doImport()"
      [disabled]="!fileUrl.value"
    >
      Import
    </button>
  </div>
</mat-dialog-actions>
